package gr.tech.meetinggenie.styles

import com.varabyte.kobweb.compose.css.BorderCollapse
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.OverflowWrap
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.VerticalAlign
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderCollapse
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.overflowWrap
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.verticalAlign
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import gr.tech.meetinggenie.util.CONSTANTS.FONT_FAMILY2
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

/* ----------- Data Entry Table (Wins / Row-Input) ------------ */

val InputSectionTitleStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .textAlign(TextAlign.Start)
            .fontSize(1.25.cssRem)
            .fontWeight(FontWeight.Bold)
            .margin(topBottom = 1.cssRem)
    }
}

val DataEntryTableStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .margin(bottom = 16.px)
            .borderRadius(8.px)
            .borderCollapse(BorderCollapse.Collapse)
    }
}

val DataEntryCellStyle = CssStyle {
    base {
        Modifier
            .border(1.px, LineStyle.Solid, Colors.Black)
            .verticalAlign(VerticalAlign.Top)
    }
}

val DataEntryRowStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .backgroundColor(Colors.Transparent)
            .transition(Transition.all(100.ms))
    }
}

val DataEntryCellTextStyle = CssStyle {
    base {
        Modifier
            .overflowWrap(OverflowWrap.BreakWord)
            .fontSize(0.875.cssRem)
            .color(Colors.Black)
    }
}

val DataEntryControlCellStyle = CssStyle {
    base {
        Modifier
            .width(25.px)
            .borderRadius(8.px)
            .padding(leftRight = 6.px, topBottom = 0.px)
            .whiteSpace(WhiteSpace.NoWrap)
            .verticalAlign(VerticalAlign.Middle)
            .textAlign(TextAlign.Center)
    }
}

val DragHandleStyle = CssStyle {
    base {
        Modifier
            .cursor(Cursor.Grab)
            .color(Colors.Gray)
            .margin(right = 4.px)
    }
    hover {
        Modifier.color(Colors.Black)
    }
}

val DeleteRowButtonStyle = CssStyle {
    base {
        Modifier
            .padding(leftRight = 4.px, topBottom = 2.px)
            .borderRadius(4.px)
            .border(1.px, LineStyle.Solid, Theme.SpectrumRed.rgb)
            .color(Theme.SpectrumRed.rgb)
            .cursor(Cursor.Pointer)
    }
    hover {
        Modifier
            .transition(Transition.all(100.ms))
            .opacity(75.percent)
    }
}

val AddRowButtonStyle = CssStyle {
    base {
        Modifier
            .margin(top = 8.px)
            .padding(leftRight = 12.px, topBottom = 6.px)
            .backgroundColor(Theme.MediumGreen.rgb)
            .noBorder()
            .borderRadius(4.px)
            .color(Colors.White)
            .fontSize(0.875.cssRem)
            .cursor(Cursor.Pointer)
    }
    hover {
        Modifier
            .transition(Transition.all(100.ms))
            .backgroundColor(Theme.DarkGreen.rgb)
    }
}